import { render } from "./ChatComponent.vue?vue&type=template&id=1d83208a&scoped=true"
import script from "./ChatComponent.vue?vue&type=script&lang=js"
export * from "./ChatComponent.vue?vue&type=script&lang=js"

import "./ChatComponent.vue?vue&type=style&index=0&id=1d83208a&lang=scss&scoped=true"
import "./ChatComponent.vue?vue&type=style&index=1&id=1d83208a&lang=css"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d83208a"]])

export default __exports__